export interface UseHomepageProps {
  homepageUrl: string
}

export const useHomepagePropsDefault: UseHomepageProps = {
  homepageUrl: '/home',
}
